export const BOOKING_STATUS = {
  PENDING: "pending",
  APPROVED: "approved",
  CANCELED: "canceled",
};

export const CONTACT_INFO = {
  email: "contact@tourbuslive.fr",
  phone: "+33 33 33 33 33",
  address: "56 Street Avenue, Morioh Town, SJ 1987",
  //make sure to get the embed link from google maps
  mapUrl:
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2624.9914406081493!2d2.292292615509614!3d48.85837360866272!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47e66e2964e34e2d%3A0x8ddca9ee380ef7e0!2sEiffel%20Tower!5e0!3m2!1sen!2sfr!4v1618491899249!5m2!1sen!2sfr",
  twitter: "https://twitter.com",
  facebook: "https://facebook.com",
  instagram: "https://instagram.com",
  youtube: "https://youtube.com",
};
